import styled from 'styled-components';

import {
  mediaConfinedNavlessOnly,
  mediaSmallOrTiny,
} from '@xing-com/layout-tokens';
import { space3XL, spaceL } from '@xing-com/tokens';

import {
  NUMBER_OF_COLUMNS_CONFINED,
  NUMBER_OF_COLUMNS_DEFAULT,
  NUMBER_OF_COLUMNS_SMALL,
} from './constants';

const getNumberOfCardItemsDisplayed = (numberOfColumns: number): number => {
  return numberOfColumns * 2;
};

export const CardsModuleContainer = styled.ul`
  display: grid;
  grid-template-columns: repeat(${NUMBER_OF_COLUMNS_DEFAULT}, 1fr);
  grid-auto-rows: 1fr;
  gap: ${spaceL};
  list-style: none;
  margin: 0;
  padding: 0;

  @media ${mediaSmallOrTiny} {
    grid-template-columns: repeat(${NUMBER_OF_COLUMNS_SMALL}, 1fr);
  }

  @media ${mediaConfinedNavlessOnly} {
    grid-template-columns: repeat(${NUMBER_OF_COLUMNS_CONFINED}, 1fr);
  }
`;

export const ButtonContainer = styled.div`
  margin-top: ${space3XL};
  text-align: center;
`;

export const SkeletonCardItem = styled.li`
  @media ${mediaSmallOrTiny} {
    display: none;

    &:nth-child(
      -n + ${getNumberOfCardItemsDisplayed(NUMBER_OF_COLUMNS_SMALL)}
    ) {
      display: block;
    }
  }

  @media ${mediaConfinedNavlessOnly} {
    display: none;

    &:nth-child(
      -n + ${getNumberOfCardItemsDisplayed(NUMBER_OF_COLUMNS_CONFINED)}
    ) {
      display: block;
    }
  }
`;
